import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=4bc1b403&scoped=true&"
import script from "./ClientSearch.vue?vue&type=script&lang=ts&"
export * from "./ClientSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ClientSearch.vue?vue&type=style&index=0&id=4bc1b403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1b403",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc1b403')) {
      api.createRecord('4bc1b403', component.options)
    } else {
      api.reload('4bc1b403', component.options)
    }
    module.hot.accept("./ClientSearch.vue?vue&type=template&id=4bc1b403&scoped=true&", function () {
      api.rerender('4bc1b403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClientSearch.vue"
export default component.exports